<template>
  <div class="app-container">
    <div class="fixedButton" style="margin-bottom: 10px">
      <vxe-button class="examineButton" @click="ReturnFun">返回</vxe-button>
      <vxe-button v-if="editFlag"  class="examineButton" status="primary" @click="onSubmit">提交</vxe-button>
      <vxe-button  v-if="approveFlag && approveBtnType === '1'" class="examineButton" status="primary" @click="handleApprove(1)">同意</vxe-button>
      <vxe-button v-if="approveFlag && approveBtnType === '1'" class="examineButton" status="danger" @click="handleApprove(2)">不同意</vxe-button>
    </div>
    <div class="item-line">活动提报信息</div>
    <div class="budgetBox bodyBox">
      <el-form ref="signUpForm" class="UniformCss" :inline="true" label-width="120px" :model="applyForm">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="申报月份" prop="actMonth" class="sign-tiem">
              <el-date-picker
                v-model="applyForm.actMonth"
                value-format="yyyy-MM"
                type="month"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="活动提报名称" class="sign-tiem">
              <el-tooltip class="item" effect="dark" :content="applyForm.planApplyName" placement="top">
                <el-input v-model="applyForm.planApplyName" disabled />
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="活动提报编码" class="sign-tiem">
              <el-input v-model="applyForm.planApplyCode" disabled placeholder="" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="提报类型" class="sign-tiem">
              <el-select v-model="applyForm.itemType" :disabled="true">
                <el-option v-for="(tiem, i) in SelectLists.TypesOfPresentation" :key="i" :value="tiem.code" :label="tiem.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="提报时间" class="sign-tiem">
              <el-input v-model="applyForm.applyTime" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="原计划开始日期" class="act-item" prop="planStartTime">
              <el-date-picker
                v-model="applyForm.planStartTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="原计划结束日期" class="sign-tiem" prop="planEndTime">
              <el-date-picker
                v-model="applyForm.planEndTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="活动预算(元)" class="sign-tiem" prop="actBudget">
              <el-input v-model="applyForm.actBudget" disabled />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="品系" prop="strainsArr">
              <el-input v-model="applyForm.strainsName" disabled />
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="提报状态" class="sign-tiem">
              <el-select v-model="applyForm.applyStatus" disabled>
                <el-option v-for="(tiem, i) in SelectLists.ActPlanApplyStatus" :key="i" :value="tiem.code" :label="tiem.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      <el-row>
          <el-col :span="8">
            <el-form-item label="集客目标" class="sign-tiem">
              <el-input v-model="applyForm.customerTarget" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单目标" class="sign-tiem">
              <el-input v-model="applyForm.orderTarget" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="新计划开始日期" class="act-item" prop="newStartTime" :rules="[{ required: true, message: '请选择开始时间!', trigger: 'blur' }]">
              <el-date-picker
                v-model="applyForm.newStartTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                :picker-options="{
                  disabledDate: time =>
                    time.getTime() < (+new Date(activity.planStartTime) > Date.now() ? +new Date(activity.planStartTime)-8.64e7 : Date.now()-8.64e7) || time.getTime() > +new Date(activity.planEndTime)
                }"
                placeholder="选择日期"
                :disabled="approveFlag"
                @change="applyForm.newEndTime && (applyForm.newEndTime = '')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="8" style="height: auto">
            <el-form-item label="计划方案" class="sign-tiem">
              <el-upload
                ref="uploadFile"
                class="upload-demo"
                action=""
                :file-list="fileList"
              />
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="8">
            <el-form-item label="新计划结束日期" class="sign-tiem" prop="newEndTime" :rules="[{ required: true, message: '请选择结束时间!', trigger: 'blur' }]">
              <el-date-picker
                v-model="applyForm.newEndTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="{ disabledDate: time => time.getTime() < new Date(applyForm.newStartTime ? applyForm.newStartTime : '') || time.getTime() > +new Date(activity.planEndTime) }"
                type="date"
                placeholder="选择日期"
                :disabled="approveFlag"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-line">计划时间调整记录</div>
    <div class="budgetBox bodyBox">
      <vxe-table
        ref="xTable"
        v-loading="listLoading"
        border
        show-header-overflow
        show-overflow
        align="center"
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        style="margin-top: 10px"
        :max-height="$store.state.app.height - 130 < 180 ? 180 : $store.state.app.height - 130"
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="adjustList"
      >
        <vxe-column type="checkbox" width="60" align="center" />
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <vxe-column field="oldStartTime" title="原计划开始时间" width="120">
          <template #default="{ row }">
            <span>{{ row.oldStartTime | dateFormat("yyyy-MM-dd") }}</span>
          </template>
        </vxe-column>
        <vxe-column field="oldEndTime" title="原计划结束时间" width="120">
          <template #default="{ row }">
            <span>{{ row.oldEndTime | dateFormat("yyyy-MM-dd") }}</span>
          </template>
        </vxe-column>
        <vxe-column field="newStartTime" title="新计划开始时间" width="120">
          <template #default="{ row }">
            <span>{{ row.newStartTime | dateFormat("yyyy-MM-dd") }}</span>
          </template>
        </vxe-column>
        <vxe-column field="newEndTime" title="新计划结束时间" width="120">
          <template #default="{ row }">
            <span>{{ row.newEndTime | dateFormat("yyyy-MM-dd") }}</span>
          </template>
        </vxe-column>
        <vxe-column field="approveStatus" title="审核状态" width="100">
          <template #default="{ row }">
            <span v-if="row.approveStatus === '0'">未通过</span>
            <span v-else-if="row.approveStatus === '1'">审核中</span>
            <span v-else>已通过</span>
          </template>
        </vxe-column>
        <vxe-column field="approveNode" title="审批节点" width="160" />
        <vxe-column field="approveAuditorNames" title="当前审批人" width="160" />
        <vxe-column field="createTime" title="创建时间" width="160" />
        <vxe-column title="操作" width="100" fixed="right" align="center">
          <template #default="{ row }">
            <div class="handle-box">
              <el-link type="primary" icon="el-icon-view" @click="viewApproveDetail(row)">审核流程</el-link>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <el-dialog title="审批信息" :visible.sync="dialogVisible" width="40%">
      <el-input
        v-model="approveMsg"
        type="textarea"
        placeholder="请输入审批意见"
        maxlength="300"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button :loading="approveBtnLoading" status="primary" @click="approve()">{{ approveTypeName }}</vxe-button>
        <vxe-button @click="dialogVisible = false">取 消</vxe-button>
      </span>
    </el-dialog>
    <el-dialog title="审批信息" :visible.sync="taskDialogVisible" width="60%">
      <vxe-table
        ref="xApprove"
        border
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        :loading="approveLoading"
        max-height="370"
        align="center"
        :scroll-y="{ enabled: false }"
        :data="taskListData"
        :reserve="true"
        :row-config="{ isCurrent: true, isHover: true }"
      >
        <vxe-column type="seq" title="序号" width="60" />
        <vxe-column field="displayName" title="节点名称" />
        <vxe-column field="operatorName" title="审批人" />
        <vxe-column field="operateType" title="操作类型" />
        <vxe-column field="approveMsg" title="审批意见" />
        <vxe-column field="finishTime" title="处理时间" />
      </vxe-table>
    </el-dialog>
  </div>
</template>
<script>
import { getActApplyDetail, getFiles, findFileInfo, findDealerActById } from '@/api/actPlan'
import { saveAdjustInfo, updateAdjustInfo, findAdjustList } from '@/api/actPlanApplyAdjust'
import { approveStart, approveExecute, findTaskInfos, findDisTaskInfos } from '@/api/wf_process.js'
// import permission from '@/directive/permission/index.js' // 权限判断指令
import { setInitImg } from '@/utils/Picture/transferFile'
import { mapGetters } from 'vuex'

const defaultApproveType = new Map([
  [0, '发起审批'],
  [1, '同 意'],
  [2, '不同意']
])

const defaultAdjustForm = {
  planApplyId: null,
  oldStartTime: null,
  oldEndTime: null,
  newStartTime: null,
  newEndTime: null,
  approveStatus: null,
  approveOrderId: null,
  approveNode: null,
  approveAuditorNames: null,
  approveAuditorIds: null,
  approveHistOrderId: null
}

export default {
  name: 'EditSignActivityDate',
  // directives: { permission },
  data() {
    return {
      domain: 'dealer',
      editFlag: false, // 编辑状态标志
      approveFlag: false, // 审批状态标志
      applyForm: {}, // 提报表单
      fileList: [], // 文件列表
      activity: {}, // 活动计划表单
      adjustForm: Object.assign({}, defaultAdjustForm), // 调整表单
      listLoading: false,
      adjustList: [],
      newStartTime: '',
      newEndTime: '',
      dialogVisible: false,
      approveMsg: '',
      approveBtnLoading: false,
      approveTypeName: '',
      approveType: defaultApproveType,
      taskDialogVisible: false,
      approveLoading: false,
      taskListData: [],
      approveBtnType: '0',
      SelectLists: {}
    }
  },
  computed: {
    ...mapGetters('account', ['user']),
  },
  created() {
    this.SelectListsFun()
    if (this.$route.params.id) {
      this.applyForm.id = this.$route.params.id
      // 获取提报详情
      this.getMarketactivityById()
    }
    if (this.$route.params.state === 'edit' && this.domain === 'dealer') {
      this.editFlag = true
    } else if (this.$route.params.state === 'approve') {
      this.approveFlag = true
    }
  },
  methods: {
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['ActPlanApplyStatus', 'TypesOfPresentation']).then(v => {
        this.SelectLists = v
      })
    },
    // 获取提报详情
    getMarketactivityById() {
      getActApplyDetail(this.applyForm.id).then(res => {
        if (res.code === 1 && res.data) {
          this.applyForm = res.data
          this.getActById(this.applyForm.planDealerId)
          this.getAdjustList()
          // this.getFileInfo(this.applyForm.planApplyCode)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取活动详情
    getActById(id) {
      const data = {
        id: id,
        planApplyId: this.applyForm.id
      }
      findDealerActById(data).then(res => {
        if (res.code === 1 && res.data) {
          this.activity = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleAppBtn() {
      if (this.approveFlag && this.adjustForm.approveAuditorIds.indexOf(this.user.userId) !== -1) {
        this.approveBtnType = '1'
      }
    },
    // 获取文件信息
    getFileInfo(code) {
      findFileInfo(code).then(res => {
        if (res.code === 1 && res.data) {
          this.fileInfoList = res.data
          this.initFile()
        }
      })
    },
    initFile() {
      if (this.fileInfoList.length < 1) {
        return
      }
      this.fileInfoList.forEach(item => {
        if (item.module === 'actPlanApply') {
          getFiles(item).then(res => {
            const file = setInitImg(res, item.name)
            this.fileList.push(file)
          })
        }
      })
    },
    // 获取调整记录
    getAdjustList() {
      this.listLoading = true
      const data = {
        applyId: this.applyForm.id
      }
      findAdjustList(data).then(res => {
        if (res.code === 1) {
          this.adjustList = res.data
          this.listLoading = false
          if (this.adjustList.length > 0 && this.approveFlag) {
            const lastIndex = this.adjustList.length - 1
            this.applyForm.newStartTime = this.adjustList[lastIndex].newStartTime
            this.applyForm.newEndTime = this.adjustList[lastIndex].newEndTime
            this.adjustForm = this.adjustList[lastIndex]
          }
          this.handleAppBtn()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    ReturnFun() {
      this.$closePage('/terminalActivity/editSignActivityDate', '/terminalActivity/signIndex')
    },
    handleApprove(type) {
      this.approveTypeName = this.approveType.get(type)
      this.dialogVisible = true
    },
    // 提交
    onSubmit() {
      const currentDate = new Date()
      const specifiedDate = new Date(this.applyForm.planStartTime)
      // 将当前日期的时分秒设为零
      currentDate.setHours(0, 0, 0, 0)
      if (currentDate.getTime() === specifiedDate.getTime() || currentDate.getTime() > specifiedDate.getTime()) {
        this.$message.error('提交失败，当前时间在计划时间内，默认活动已开始执行')
        return
      }
      if (this.countAdjustTimes()) {
        return
      }
      this.$refs['signUpForm'].validate(valid => {
        if (valid) {
          this.handleApprove(0)
        } else {
          this.$message.error('请检查表单，完成所有必填项目！')
          return false
        }
      })
    },
    // 保存表单
    saveFun() {
      const data = Object.assign({}, this.adjustForm)
      this.approveBtnLoading = true
      saveAdjustInfo(data).then(res => {
        if (res.code === 1) {
          this.approveBtnLoading = false
          this.$message.success('操作成功')
          this.ReturnFun()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    updateFun() {
      const data = Object.assign({}, this.adjustForm)
      this.approveBtnLoading = true
      updateAdjustInfo(data).then(res => {
        if (res.code === 1) {
          this.$message.success('操作成功')
          this.approveBtnLoading = false
          this.ReturnFun()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    countAdjustTimes() {
      if (this.adjustList.length > 0) {
        // 筛选 approveStatus 等于 2 的对象
        const arr = this.adjustList.filter(item => item.approveStatus === '2')
        if (arr.length > 2) {
          this.$message.error('调整次数已达上限')
          return true
        }
      }
      return false
    },
    approve() {
      if (this.approveTypeName === '发起审批') {
        this.$store.dispatch('SelectData/QuerySelect', ['adjustProcessMap']).then(v => {
          const obj = v.adjustProcessMap.find(item => item.code === '0')
          if (!obj) {
            this.$message.error('未配置审批流')
            return
          }
          this.approveStartFun(obj)
        })
      }
      // 审批
      if (this.approveTypeName === '同 意') {
        this.approveExecuteFun()
      }
      // 驳回
      if (this.approveTypeName === '不同意') {
        this.disagreeFun()
      }
    },
    // 发起流程
    approveStartFun(obj) {
      const approveParam = {
        processName: obj.value,
        args: {
          approveMsg: this.approveMsg,
          businessCode: this.applyForm.planApplyCode,
          businessName: this.applyForm.planApplyName
        }
      }
      this.approveBtnLoading = true
      // 发起流程
      approveStart(approveParam).then(res => {
        if (res.code === 1) {
          this.approveBtnLoading = false
          this.adjustForm.approveOrderId = res.data.orderId
          this.adjustForm.approveNode = res.data.approveNode
          this.adjustForm.approveStatus = '1'
          this.adjustForm.approveAuditorNames = res.data.operatorInfos[0].operatorNames
          this.adjustForm.approveAuditorIds = res.data.operatorInfos[0].operatorIds
          this.adjustForm.planApplyId = this.applyForm.id
          this.adjustForm.oldStartTime = this.applyForm.planStartTime
          this.adjustForm.oldEndTime = this.applyForm.planEndTime
          this.adjustForm.newStartTime = this.applyForm.newStartTime
          this.adjustForm.newEndTime = this.applyForm.newEndTime
          this.saveFun()
        }
      })
    },
    // 同意
    approveExecuteFun() {
      const approveParam = {
        orderId: this.adjustForm.approveOrderId,
        args: {
          approveMsg: this.approveMsg,
          businessCode: this.applyForm.planApplyCode,
          businessName: this.applyForm.planApplyName
        }
      }
      this.approveBtnLoading = true
      approveExecute(approveParam).then(res => {
        if (res.code === 1) {
          this.approveBtnLoading = false
          if (res.data.endFlg === true) {
            this.adjustForm.approveStatus = '2'
            this.adjustForm.approveNode = ''
            this.adjustForm.approveOrderId = ''
            this.adjustForm.approveAuditorNames = ''
            this.adjustForm.approveAuditorIds = ''
            this.adjustForm.approveHistOrderId = res.data.orderId
          } else {
            this.adjustForm.approveNode = res.data.approveNode
            this.adjustForm.approveAuditorNames = res.data.operatorInfos[0].operatorNames
            this.adjustForm.approveAuditorIds = res.data.operatorInfos[0].operatorIds
          }
          this.updateFun()
        }
      })
    },
    // 不同意
    disagreeFun() {
      if (this.approveMsg === '') {
        this.$message.warning('审批意见不能为空')
        return
      }
      const approveParam = {
        orderId: this.adjustForm.approveOrderId,
        disagree: '1',
        args: {
          approveMsg: this.approveMsg,
          businessCode: this.applyForm.planApplyCode,
          businessName: this.applyForm.planApplyName
        }
      }
      this.approveBtnLoading = true
      approveExecute(approveParam).then(res => {
        if (res.code === 1) {
          this.approveBtnLoading = false
          this.adjustForm.approveHistOrderId = this.adjustForm.approveOrderId
          this.adjustForm.approveStatus = '0'
          this.adjustForm.approveNode = ''
          this.adjustForm.approveOrderId = ''
          this.adjustForm.approveAuditorNames = ''
          this.adjustForm.approveAuditorIds = ''
          this.updateFun()
        }
      })
    },
    // 查看审批流程
    viewApproveDetail(row) {
      this.taskDialogVisible = true
      this.approveLoading = true
      const param = {
        orderId: row.approveOrderId || row.approveHistOrderId
      }
      if (row.approveStatus === '0') {
        findDisTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.taskListData = res.data
            this.approveLoading = false
          }
        })
      } else {
        findTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.taskListData = res.data
            this.taskListData.forEach(item => {
              if (!item.his) {
                item.operatorName = row.approveAuditorNames
                item.finishTime = '正在处理'
              }
            })
            this.approveLoading = false
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.item-line {
  padding: 0px 20px;
  width: 100%;
  margin: 0;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.usereq {
  .el-row {
    margin: 5px 0 !important;
  }
  .grid-content,
  .grid-Prohibit {
    text-align: center;
    font-size: 16px;
    border-radius: 4px;
    min-height: 36px;
  }
  .grid-content .el-checkbox__label {
    font-size: 16px;
  }
  .left_content {
    height: 80%;
    padding: 0 10px 10px 10px;
    overflow-y: auto;
    border-radius: 5px;
  }
  .center_content {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  .el-select.el-input--small .el-input__inner {
    color: #616b80;
    width: 100%;
    background: #152841;
    border-color: #152841;
    border-radius: 5px;
  }
  .el-checkbox-group .el-checkbox__label {
    display: none;
  }
  .center {
    text-align: center;
  }
  .center_content_r {
    width: 90%;
    height: 200px;
    margin-top: 20px;
  }
  .rule_btn {
    width: 100%;
    height: 60px;
    background: #28548e;
    float: left;
    border: none;
  }
  .rule_btn_left,
  .rule_btn_right {
    background: #1074f6;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 3px;
  }
  .rule_btn_left img {
    transform: rotate(180deg);
  }
  .rule_btn_left:hover,
  .rule_btn_right:hover {
    background: #1e3a5f;
  }
  .dialog-footer {
    width: 100px;
  }
}
/deep/ .el-input__inner {
  height: 30px!important;
}

 ::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 200px !important
}
::v-deep .el-col-8{
  padding-left: 0px !important;
  padding-right: 0px !important;
}

::v-deep .el-row{
  margin-left: 0px !important;
  margin-right: 0px !important;
}

</style>
